import Model from './model.js';
import FileInfo from './fileInfo.js';

export default class SacrificeData extends Model
{
    constructor(id, personId, healthNumber, disabilityRate, governorate, district, township, region, dateOfMedical, decisionOfMedical, injuryDetails, dateSacrifice, hospitalName, typesInjurie, bodyMainPart, bodySide, bodySubPart, note, file=null){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.healthNumber       = healthNumber;
        this.disabilityRate     = disabilityRate;
        this.governorate        = governorate;
        this.district           = district;
        this.township           = township;
        this.region             = region;
        this.dateOfMedical      = dateOfMedical;
        this.decisionOfMedical  = decisionOfMedical;
        this.injuryDetails      = injuryDetails;
        this.dateSacrifice      = dateSacrifice;
        this.hospitalName       = hospitalName;
        this.typesInjurie       = typesInjurie;
        this.bodyMainPart       = bodyMainPart;
        this.bodySide           = bodySide;
        this.bodySubPart        = bodySubPart;
        this.note               = note;
        this.file               = file ?? new FileInfo();

        this.init()
    }

    setBinaryFile(binaryFile){
        if (!this.file || typeof this.file !== 'object') this.file = new FileInfo();
        this.file.binaryFile = binaryFile ?? null;
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        let formData = new FormData();

        formData.append("healthNumber", this.healthNumber ?? "");
        formData.append("disabilityRate", this.disabilityRate ?? "");
        formData.append("placeOfInjury", this.region?.value ?? "");
        formData.append("dateOfMedical", this.dateOfMedical ?? "");
        formData.append("decisionOfMedical", this.decisionOfMedical ?? "");
        formData.append("injuryDetails", this.injuryDetails ?? "");
        formData.append("dateSacrifice", this.dateSacrifice ?? "");
        formData.append("hospitalName", this.hospitalName ?? "");
        formData.append("typesInjurie", this.typesInjurie?.value ?? "");
        formData.append("bodyMainPart", this.bodyMainPart?.value ?? "");
        formData.append("bodySide", this.bodySide?.value ?? "");
        formData.append("bodySubPart", this.bodySubPart?.value ?? "");
        formData.append("note", this.note ?? "");

        if (this.file?.binaryFile) formData.append('file', this.file.binaryFile);
        return formData;
    }

    mapToCreate(){
        let formData = new FormData();
        formData.append('personId', this.personId ?? null);
        formData.append("healthNumber", this.healthNumber ?? "");
        formData.append("disabilityRate", this.disabilityRate ?? "");
        formData.append("placeOfInjury_id", this.region?.value ?? "");//change next time
        formData.append("dateOfMedical", this.dateOfMedical ?? "");
        formData.append("decisionOfMedical", this.decisionOfMedical ?? "");
        formData.append("injuryDetails", this.injuryDetails ?? "");
        formData.append("dateSacrifice", this.dateSacrifice ?? "");
        formData.append("hospitalName", this.hospitalName ?? "");
        formData.append("typesInjuries_id", this.typesInjurie?.value ?? "");//change next time
        formData.append("bodyMainPart_id", this.bodyMainPart?.value ?? "");//change next time
        formData.append("bodySide_id", this.bodySide?.value ?? "");//change next time
        formData.append("bodySubPart_id", this.bodySubPart?.value ?? "");//change next time
        formData.append("notes", this.note ?? "");// change next time
        if (this.file?.binaryFile) formData.append('file', this.file.binaryFile);
        
        return formData;
    }
}

